@let informations = information$ | async;
@let top3 = top3$ | async;
@let trainingSections = trainingSections$ | async;

<app-generic-view
  type="gps"
  [backgroundImage]="
    informations ? 'url(' + informations.thumbnails + ')' : null
  "
  [information]="informations"
  [comments$]="comments$"
  [top3$]="top3$"
  [showRanking]="true"
  (onLikeClick)="onLikeClick($event)"
  (onDownloadClick)="onDownloadGPX($event)"
  (getComments)="getComments()"
  (getTop3)="getTop3()"
  (onEditPost)="editGpsOnly($event)">
  <kin-gps-player
    [coordinates$]="coordinates$"
    [trainingSections$]="trainingSections$"
    [informations$]="information$" />
</app-generic-view>
